import React from 'react';
import { motion } from 'framer-motion';
const skills = ['Primera venta', 'Stock que rota', 'Precios correctos', 'Instagram que vende', 'Showroom profesional', 'Clientas fieles', 'Marca propia', 'Red de revendedoras'];
export function SystemPresentation() {
  return <section className="w-full py-10 sm:py-20" data-id="element-248">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-249">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center" data-id="element-250">
          <p className="text-gold text-xs sm:text-sm tracking-widest mb-3 sm:mb-4" data-id="element-251">
            SISTEMA N°1 EN ARGENTINA
          </p>
          <h2 className="font-display text-3xl sm:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6" data-id="element-252">
            MEGAPACK EMPRENDEDORA DE MODA
          </h2>
          <p className="text-lg sm:text-2xl text-violet-100/80 mb-5 sm:mb-8" data-id="element-253">
            Sistema completo · 8 Guías + 8 Bonos · Desde cero hasta tu propia
            marca · Todo resuelto.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="bg-violet-rich/30 border border-gold/20 rounded-xl p-5 sm:p-12 mt-8 sm:mt-12" data-id="element-254">
          <div className="grid grid-cols-3 sm:grid-cols-3 gap-4 sm:gap-8 mb-8 sm:mb-12" data-id="element-255">
            <div className="text-center" data-id="element-256">
              <p className="text-3xl sm:text-5xl font-display font-bold text-gold mb-1 sm:mb-2" data-id="element-257">
                +360
              </p>
              <p className="text-[10px] sm:text-base text-violet-100/70" data-id="element-258">
                páginas de contenido aplicable
              </p>
            </div>
            <div className="text-center" data-id="element-259">
              <p className="text-3xl sm:text-5xl font-display font-bold text-gold mb-1 sm:mb-2" data-id="element-260">
                8
              </p>
              <p className="text-[10px] sm:text-base text-violet-100/70" data-id="element-261">
                guías paso a paso
              </p>
            </div>
            <div className="text-center" data-id="element-262">
              <p className="text-3xl sm:text-5xl font-display font-bold text-gold mb-1 sm:mb-2" data-id="element-263">
                8
              </p>
              <p className="text-[10px] sm:text-base text-violet-100/70" data-id="element-264">
                bonos estratégicos
              </p>
            </div>
          </div>

          <p className="text-center text-sm sm:text-base text-violet-100/80 mb-6 sm:mb-8" data-id="element-265">
            Proveedores · Precios · Instagram · Showroom · Fidelización · Marca
            propia · Sistema semanal · Revendedoras
          </p>

          <div className="h-px bg-gold/20 my-6 sm:my-8" data-id="element-266"></div>

          <p className="text-center text-xs sm:text-base text-violet-100/70 mb-4 sm:mb-6" data-id="element-267">
            Habilidades que desarrollás con el sistema:
          </p>
          <div className="flex flex-wrap justify-center gap-2 sm:gap-3" data-id="element-268">
            {skills.map((skill, index) => <motion.span key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05
          }} whileHover={{
            scale: 1.05,
            backgroundColor: 'rgba(212, 175, 55, 0.1)',
            borderColor: 'rgba(212, 175, 55, 0.4)'
          }} className="bg-violet-deep/60 border border-gold/20 px-3 py-1.5 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm text-violet-100/90 cursor-default transition-colors" data-id="element-269">
                {skill}
              </motion.span>)}
          </div>

          <p className="text-center text-violet-100/60 mt-6 sm:mt-8 text-[10px] sm:text-sm" data-id="element-270">
            Funciona desde hoy en tu casa, tu showroom o donde estés.
          </p>
        </motion.div>
      </div>
    </section>;
}